import {
  UpdateUserConsentRequestSchema,
  UpdateUserConsentResponseSchema,
} from "@amzn/client-workbench-api-model";
import { API } from "@aws-amplify/api";

import { API_METRICS_HANDLE } from "@/apis/constants";
import { Logger } from "@/apis/Logger";
import {
  publishQueryLatencyMetrics,
  publishQueryResultMetrics,
} from "@/apis/Metrics";

import { AMPLIFY_DEFAULT_API_NAME } from "../amplifyConfig";

export const SUBMIT_USER_CONSENTS_QUERY_KEY = "SubmitUserConsents";
export const SUBMIT_USER_CONSENTS_API_PATH = "/user/consents";

/**
 * Store user consents of agreeing to EZO for collecting their biometrics data in the database.
 *
 * @returns Promise<UpdateUserConsentResponseSchema> - Promise that resolves when the user consents are stored in the database.
 *
 */
export const submitUserConsents =
  async (): Promise<UpdateUserConsentResponseSchema> => {
    const startTime = new Date().getTime();
    try {
      const updateUserConsentRequestBody: UpdateUserConsentRequestSchema = {
        idvSystem: "IVV",
        idvType: "AUTOMATED_IVV_VERIFICATION",
      } as const;
      const response: UpdateUserConsentResponseSchema = (await API.post(
        AMPLIFY_DEFAULT_API_NAME,
        SUBMIT_USER_CONSENTS_API_PATH,
        {
          body: updateUserConsentRequestBody,
        }
      )) as UpdateUserConsentResponseSchema;

      publishQueryResultMetrics({
        metricsPublisherHandler: API_METRICS_HANDLE,
        queryFunctionName: SUBMIT_USER_CONSENTS_QUERY_KEY,
        numSuccess: 1,
        numFailures: 0,
      });

      return response;
    } catch (err) {
      void Logger.errorErrorLike(`Failed to store user consents.`, err);
      publishQueryResultMetrics({
        metricsPublisherHandler: API_METRICS_HANDLE,
        queryFunctionName: SUBMIT_USER_CONSENTS_QUERY_KEY,
        numSuccess: 0,
        numFailures: 1,
      });
      throw err;
    } finally {
      const elapsedTime = new Date().getTime() - startTime;
      publishQueryLatencyMetrics({
        metricsPublisherHandler: API_METRICS_HANDLE,
        queryFunctionName: SUBMIT_USER_CONSENTS_QUERY_KEY,
        elapsedTime: elapsedTime,
      });
    }
  };
